import { useContext } from 'react';
import { Toaster } from '../context';

export function useToaster() {
  return useContext(Toaster);
}
